const AnalogContext = React.createContext();

export const AnalogProvider = AnalogContext.Provider;
export const AnalogConsumer = AnalogContext.Consumer;

export default AnalogContext;



// WEBPACK FOOTER //
// ./src/js/app/AnalogContext.js